module.exports = __webpack_public_path__ + "static/media/vaken.6999a7ee.m4a";